var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 147,
    viewBox: "0 0 145 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_785_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_785_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 62C108 42.67 92.33 27 73 27C53.67 27 38 42.67 38 62C38 81.33 53.67 97 73 97C92.33 97 108 81.33 108 62Z",
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_785_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 97H50C52.765 94.6667 61.1567 90 72.6037 90C84.0507 90 92.3041 94.6667 95 97Z",
    fill: "url(#paint0_linear_785_2)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_785_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4044 66.0097C70.7768 69.2956 70.012 72.4456 67.7438 74.0909C67.0446 69.125 68.7711 65.3964 69.5741 61.4375C68.2056 59.1347 69.7388 54.5029 72.6227 55.6447C76.1723 57.0479 69.5491 64.2021 73.9948 65.0969C78.6374 66.0288 80.5321 57.0431 77.653 54.1211C73.4948 49.8997 65.5472 54.022 66.5256 60.0654C66.7631 61.5425 68.2891 61.9899 67.1353 64.029C64.4734 63.4396 63.6788 61.3397 63.7814 58.5405C63.946 53.9588 67.8966 50.7528 71.8602 50.3077C76.8727 49.7458 81.5773 52.1488 82.2276 56.8629C82.959 62.1856 79.9653 67.951 74.6045 67.5357C73.1512 67.4224 72.5427 66.7017 71.4044 66.0097Z",
    fill: "url(#paint1_linear_785_2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.323 49.0875C66.993 49.1502 66.0848 49.3625 65.2907 49.6744C64.4691 49.9947 63.7725 50.4244 63.0795 51.1199C62.3866 51.8154 61.9597 52.5124 61.6418 53.3355C61.334 54.1311 61.1255 55.0402 61.0668 56.3709C61.008 57.7017 60.995 58.1295 61.0015 61.524C61.008 64.9184 61.023 65.3439 61.0875 66.6775C61.151 68.0072 61.3625 68.9152 61.6745 69.7094C61.9953 70.5312 62.4245 71.2275 63.1203 71.9207C63.816 72.6139 64.5125 73.0397 65.3375 73.3582C66.1325 73.6655 67.0418 73.8749 68.3723 73.9332C69.7028 73.9915 70.1311 74.005 73.5246 73.9985C76.9182 73.992 77.3455 73.9769 78.6786 73.9137C80.0119 73.8505 80.9151 73.6374 81.7097 73.3269C82.5314 73.0055 83.2282 72.5769 83.9209 71.881C84.6136 71.185 85.0402 70.4875 85.3579 69.6639C85.6659 68.8689 85.8752 67.9598 85.9329 66.6302C85.9912 65.2959 86.005 64.87 85.9985 61.476C85.992 58.082 85.9767 57.6565 85.9134 56.3234C85.8502 54.9904 85.6384 54.0852 85.3267 53.2904C85.0054 52.4687 84.5767 51.7729 83.8812 51.0792C83.1857 50.3854 82.4876 49.9592 81.6645 49.6422C80.8688 49.3344 79.9602 49.1247 78.6296 49.0672C77.2991 49.0097 76.8709 48.9948 73.4761 49.0015C70.0813 49.0079 69.6563 49.0225 68.323 49.0875ZM68.4691 71.6844C67.2503 71.6314 66.5885 71.4289 66.1475 71.2594C65.5635 71.0344 65.1475 70.7625 64.708 70.3271C64.2684 69.8919 63.9985 69.4744 63.7705 68.8917C63.5993 68.4507 63.393 67.7897 63.336 66.5709C63.2741 65.2537 63.261 64.8582 63.2537 61.5209C63.2465 58.1837 63.2593 57.7886 63.317 56.4709C63.3691 55.2532 63.5728 54.5907 63.742 54.1499C63.967 53.5652 64.238 53.1499 64.6743 52.7107C65.1105 52.2715 65.5268 52.0009 66.11 51.7729C66.5506 51.6009 67.2116 51.3965 68.4298 51.3384C69.748 51.2759 70.143 51.2634 73.4798 51.2562C76.8166 51.2489 77.2127 51.2614 78.5314 51.3195C79.7491 51.3724 80.4119 51.5742 80.8523 51.7445C81.4364 51.9695 81.8523 52.2397 82.2914 52.6768C82.7307 53.1137 83.0014 53.5284 83.2295 54.1129C83.4017 54.5522 83.6062 55.2129 83.6637 56.432C83.7264 57.7502 83.7407 58.1455 83.7467 61.482C83.7527 64.8184 83.7409 65.2147 83.6831 66.5319C83.63 67.7507 83.4279 68.4127 83.2581 68.8542C83.0331 69.438 82.762 69.8542 82.3254 70.2932C81.8889 70.7322 81.4732 71.0027 80.8897 71.2307C80.4497 71.4025 79.7879 71.6075 78.5707 71.6655C77.2524 71.7275 76.8574 71.7405 73.5193 71.7478C70.1813 71.7551 69.7873 71.7415 68.4691 71.6844ZM78.6594 54.8192C78.6599 55.1159 78.7484 55.4058 78.9137 55.6522C79.0789 55.8986 79.3136 56.0904 79.5879 56.2035C79.8622 56.3165 80.1639 56.3457 80.4548 56.2873C80.7457 56.2289 81.0127 56.0855 81.2221 55.8753C81.4315 55.6651 81.5739 55.3976 81.6312 55.1065C81.6885 54.8154 81.6582 54.5138 81.5441 54.2399C81.4301 53.966 81.2373 53.7321 80.9903 53.5678C80.7432 53.4034 80.453 53.3161 80.1563 53.3167C79.7586 53.3175 79.3775 53.4762 79.0968 53.758C78.8161 54.0398 78.6588 54.4215 78.6594 54.8192ZM67.0818 61.5125C67.0888 65.0575 69.9678 67.9247 73.512 67.918C77.0564 67.9112 79.9256 65.0325 79.9189 61.4875C79.9122 57.9425 77.0325 55.0745 73.4876 55.0815C69.9428 55.0884 67.0751 57.9679 67.0818 61.5125ZM69.3334 61.508C69.3317 60.6839 69.5745 59.8779 70.031 59.1918C70.4875 58.5057 71.1372 57.9703 71.8979 57.6535C72.6586 57.3366 73.4962 57.2524 74.3048 57.4116C75.1134 57.5708 75.8566 57.9661 76.4405 58.5477C77.0243 59.1292 77.4227 59.8708 77.585 60.6788C77.7474 61.4867 77.6666 62.3246 77.3527 63.0866C77.0389 63.8486 76.5061 64.5004 75.8218 64.9596C75.1376 65.4188 74.3325 65.6648 73.5084 65.6664C72.9612 65.6676 72.4191 65.5609 71.9131 65.3526C71.4072 65.1442 70.9472 64.8382 70.5595 64.452C70.1718 64.0659 69.864 63.6071 69.6536 63.102C69.4432 62.5968 69.3344 62.0552 69.3334 61.508Z",
    fill: "#9F0812"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_785_2",
    x: 38,
    y: 22,
    width: 75,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_785_2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.304527 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_785_2",
    result: "effect2_innerShadow_785_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_785_2",
    x: 0,
    y: 40,
    width: 145,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_785_2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_785_2",
    x: 13.7728,
    y: 0.227295,
    width: 118.564,
    height: 123.864,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_785_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_785_2",
    x1: 88.4131,
    y1: 91.0246,
    x2: 86.9093,
    y2: 100.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF004E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E90018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_785_2",
    x1: 80.9783,
    y1: 48.7155,
    x2: 59.1431,
    y2: 61.5965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9007E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 147,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.059f215ead3f31059064ac830512832a.svg";
export { ForwardRef as ReactComponent };